var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickenEggs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82764 12.6327C1.82764 17.3387 4.90333 20.415 9.60995 20.415C14.3166 20.415 17.3923 17.3394 17.3923 12.6327C17.3923 7.92611 14.3159 0.415039 9.60995 0.415039C4.90402 0.415039 1.82764 7.92681 1.82764 12.6327Z",
    fill: "#F0A97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5416 10.3959C15.2048 10.3959 14.9008 10.1644 14.822 9.8227C14.5522 8.65406 14.1449 7.48891 13.6457 6.45415C13.4679 6.08669 13.6227 5.64461 13.9902 5.46681C14.3576 5.289 14.7997 5.4438 14.9775 5.81126C15.5242 6.94364 15.9683 8.21548 16.2626 9.4894C16.3546 9.88755 16.1064 10.2843 15.7089 10.3763C15.6532 10.3896 15.5967 10.3959 15.5416 10.3959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1457 4.91317C12.9191 4.91317 12.6953 4.80928 12.5503 4.61264C12.2986 4.27028 12.0378 3.96627 11.7756 3.70828C11.4848 3.4217 11.4813 2.95382 11.7679 2.66306C12.0545 2.37229 12.5224 2.36881 12.8131 2.65539C13.1297 2.96777 13.4421 3.33105 13.7398 3.73547C13.9818 4.06389 13.9121 4.52688 13.5829 4.76953C13.4512 4.86645 13.2978 4.91317 13.1457 4.91317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32118 0.425495C6.05932 2.44202 4.04558 8.08578 4.04558 11.8936C4.04558 16.6002 7.12127 19.6759 11.8279 19.6759C12.4345 19.6759 13.0147 19.6243 13.5641 19.5253C12.4429 20.1027 11.1091 20.415 9.60995 20.415C4.90333 20.415 1.82764 17.3387 1.82764 12.6327C1.82764 7.92611 4.77842 0.724627 9.32118 0.425495Z",
    fill: "#E3A177"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenEggs);
export default __webpack_public_path__ + "static/media/chicken-eggs.990ffce6bebfa15cda1f48502380e83d.svg";
export { ForwardRef as ReactComponent };